import { useState } from "react";
import { Modal, Header } from "semantic-ui-react";
import pollsCss from "../../../assets/styles/polls/polls.module.scss";
import { Icon } from "semantic-ui-react";
import imagesCss from "../../../assets/styles/images/images.module.scss";
export const CopyInstruction = () => {
  const [open, setOpen] = useState(false);
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        <Header
          as="h5"
          style={{
            color: "#4E84A1",
            cursor: "pointer",
            margin: "0",
          }}
        >
          How to use this?
        </Header>
      }
      size="small"
      closeIcon
    >
      <Header textAlign="center" content="How to use it?" />
      <Modal.Content>
        <p className={imagesCss.copyCodeModalContent}>
          Paste this HTML code in your email marketing platform’s HTML block.
          Make sure to change <code>{"{{KEYWORD_VALUE}}"}</code> for your email
          marketing platform's variable. This will show the correct image to
          each recipient based on the variable sent by your email software.
        </p>
      </Modal.Content>
      <div className={pollsCss.instruction_modal_footer}>
        <Modal.Actions className={pollsCss.action_border}>
          <p>
            <Icon name="mail" /> In case you experience any difficulties, feel
            free to send us a message at{" "}
            <a href="mailto:support@sendtric.com">support@sendtric.com</a>.
          </p>
        </Modal.Actions>
      </div>
    </Modal>
  );
};
